export const RATING_TYPE = [
  "indicator", //индикатор
  "total", //итог
  "title", // заголовок
];

export const REQUIRED_INDICATORS = [
  "quarter1",
  "quarter2",
  "quarter1_2",
  "quarter3",
  "quarter2_3",
  "quarter4",
  "quarter3_4",
  "yearValue",
  "yearPercent",
];

export const REQUIRED_INDICATORS_INPUT = ["sort", "name", "nameEn"];
export const NUMERIC_INDICATORS_INPUT = ["sort", "round", "format"];
